<template>
  <table-list
      ref="list"
      @query="handleLoadList"
      :request-params="{focusNum: $route.query.num}"
      v-bind="$attrs"
      :data="tableData">
    <el-table-column align="center" :label="$t('编号')" prop="focusNum" />
    <el-table-column align="center" :label="$t('头像')">
      <template v-slot="{row}">
        <preview-img :size="60" :img-url="row.portrait"></preview-img>
      </template>
    </el-table-column>
    <el-table-column align="center" prop="nickname" :label="$t('昵称')" />
    <el-table-column align="center" prop="fansCount" :label="$t('粉丝数')" />
    <el-table-column align="center" prop="focusCount" :label="$t('关注数')" />
    <el-table-column align="center" :label="$t('关注时间')">
      <template v-slot="{row}">{{row.createTime | formatDate}}</template>
    </el-table-column>
  </table-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
export default {
  name: "FollowRecord",
  components: {PreviewImg, TableList},
  props: {
    tabCurrent: {
      type: String,
      default: ""
    },
    current: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      tableData: []
    }
  },
  methods:  {
    async handleLoadList(params, setTotal) {
      try {
        let res = await request(this.$api.fans.list, params);
        for (const key in res) {
          if(Array.isArray(res[key])) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager.itemCount);
      }catch(e) {
        console.log(e);
      }
    }
  },
  watch: {
    current: {
      handler(val) {
        if(val === this.tabCurrent) {
          this.$nextTick(() => {
            this.$refs.list.handleRequest();
          })
        }
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>

.el-image {
  width: 70px;
  height: 70px;
  border-radius: 10px;
}

</style>